import Page from "@/components/integra-porto-remocao/layout/Layout"

export default [
  {
    path: '/integra/porto-remocao', component: Page, name: 'integra.porto-remocao', children: [
      {
        path: '',
        component: () => import('./components/Principal.vue'),
        name: 'integra.porto-remocao.main'
      },
      {
        path: 'salvados',
        component: () => import('./components/ListaSalvados.vue'),
        name: 'integra.porto-remocao.salvados'
      }
    ]
  }
]
